import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emptyDash'
})
export class EmptyDashPipe implements PipeTransform {

  transform(value: string | number): string | number {
    return value == null || value === '' ? '—' : value;
  }

}
